import { render, staticRenderFns } from "./edit-group.vue?vue&type=template&id=5d2fb616&scoped=true"
import script from "./edit-group.vue?vue&type=script&lang=ts"
export * from "./edit-group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2fb616",
  null
  
)

export default component.exports